import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";

import { createShipmentPackageApi, updateShippingPackageApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedCalPackage, clearSelectedPackage } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const AddShipmentPackage = () => {
    const navigate = useNavigate()

    const { selectedCalPackage } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);



    const [pakWeight, setPakWeight] = useState('');
    const [airDuration, setAirDuration] = useState('');

    const [airCost, setAirCost] = useState('');
    const [shipDuration, setShipDuration] = useState('');
    const [shipCost, setShipCost] = useState('');




    const [shipPackageId, setShipPackageId] = useState(''); // can be generated or user-input







    const handleSubmit = async (e) => {



        e.preventDefault();






        const payloadData = {
            air_amount: airCost,
            air_duration: airDuration,
            package_weight: pakWeight,
            ship_amount: shipCost,
            ship_duration: shipDuration,
            id: shipPackageId






        }



        try {



            const res = shipPackageId ? await updateShippingPackageApi(payloadData) : await createShipmentPackageApi(payloadData);
            console.log('Success:', res);
            toast.success(res.message || "Success")
            navigate("/shipment-calculator")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }


    };




    useEffect(() => {
        if (selectedCalPackage) {
            setPakWeight(selectedCalPackage?.package_weight || '')
            setAirDuration(selectedCalPackage?.air_duration || '')
            setAirCost(selectedCalPackage?.costPerKGAir.toFixed(2) || '')
            setShipDuration(selectedCalPackage?.ship_duration || '')
            setShipCost(selectedCalPackage?.ship_amount.toFixed(2) || '')
            setShipPackageId(selectedCalPackage?.id || '')










        }

        return () => {

            dispatch(clearSelectedCalPackage());
        };
    }, [selectedCalPackage, dispatch]);

    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };





    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Shipment Calculation Management</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>

                            <div className="row">
                                <div className="col-12  mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='pakWeight'>
                                        Package Weight (KG):
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='pakWeight'
                                        placeholder='Enter Applicable Package Weight'
                                        value={pakWeight}
                                        onChange={(e) => handleNumericInput(e, setPakWeight)}
                                    />
                                </div>

                            </div>

                            <div className="row">


                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='airDuration'>
                                        Air Duration (In Days) :
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='airDuration'
                                        placeholder='ex : 70 - 80'
                                        value={airDuration}
                                        onChange={(e) => setAirDuration(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='airCost'>
                                        Air Cost :
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='airCost'
                                        placeholder='Enter Applicable Air Cost'
                                        value={airCost}
                                        onChange={(e) => handleNumericInput(e, setAirCost)}
                                    />
                                </div>
                            </div>


                            <div className="row">


                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='shipDuration'>
                                        Ship Duration  (In Days) :
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='shipDuration'
                                        placeholder='ex: 44 - 55'
                                        value={shipDuration}
                                        onChange={(e) => setShipDuration(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='shipCost'>

                                        Ship Cost :
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='shipCost'
                                        placeholder='Enter Applicable Ship Cost'
                                        value={shipCost}
                                          onChange={(e) => handleNumericInput(e, setShipCost)}
                                    />
                                </div>
                            </div>










                            <button type='submit' className='btn btn-primary-600 radius-8 col-12'>
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default AddShipmentPackage;
